import * as React from 'react';
import { cityIn } from 'lvovich';
import { useTranslation } from 'react-i18next';
import { getDurationString, getFlightDuration } from '../../../Results/utils';
import { useTheme } from '../../../theme';
const TotalDuration = props => {
    var _a;
    const { lastSegment, flight, separator = '-' } = props;
    const { TotalDuration: theme } = useTheme('DesktopFlightRoute');
    const { t } = useTranslation('DesktopFlightInfo');
    return (React.createElement(React.Fragment, null,
        ((_a = lastSegment.stops) === null || _a === void 0 ? void 0 : _a.length) > 0 && (React.createElement("span", { className: theme.duration__stops },
            t('DesktopFlightInfo:TechnicalLandingIn', {
                count: lastSegment.stops.length
            }),
            ' ',
            lastSegment.stops.map(stop => cityIn(stop.airport.city.name)).join(', '),
            ".")),
        flight.segments.length > 1 && (React.createElement("span", null,
            t(`Total duration`),
            " ",
            separator,
            " ",
            getDurationString(getFlightDuration(flight.segments))))));
};
export default TotalDuration;
